import React, { Component } from 'react';

import classNames from 'classnames';
import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import './Toggle.scss';

@translate()
class Toggle extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    hideLabel: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    t: PropTypes.func,
    disabled: PropTypes.bool
  };

  state = {
    checked: void 0
  };

  static getDerivedStateFromProps(props, state) {
    return props.checked !== state.checked ? { checked: props.checked } : null;
  }

  onClick = () => {
    const { id, disabled, onChange } = this.props;

    if (!disabled) {
      const checked = !this.state.checked;

      this.setState({ checked });
      onChange &&
        onChange({
          target: { name: id, value: checked, checked, type: 'checkbox' }
        });
    }
  };

  render() {
    const { className, name, id, hideLabel, disabled, t } = this.props;
    const { checked } = this.state;
    const classComponent = classNames(
      'toggle_container hot-form hot-form--custom hot-form--switch',
      className,
      {
        'hide--label': hideLabel
      }
    );
    const label = checked ? 'general.yes' : 'general.no';

    return (
      <div className={classComponent}>
        <input
          type="checkbox"
          role="switch"
          className="hot-form__input"
          name={name}
          id={id}
          checked={checked || false}
          readOnly
        />
        <label
          className={classNames('hot-form__label', { disabled })}
          onClick={this.onClick}
          data-test="toggle"
          aria-hidden
        >
          <span>{t(label).toUpperCase()}</span>
        </label>
      </div>
    );
  }
}

export default Toggle;
